import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyDialogModule as MatDialogModule, MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/legacy-dialog';
import { MvdModalService } from './services/modal/mvd-modal.service';

@NgModule({
    imports: [ MatDialogModule, MatFormFieldModule, MatInputModule, MatSelectModule ],
    exports: [ MatDialogModule, MatFormFieldModule, MatInputModule, MatSelectModule ]
})
export class MaterialModule {
    static forRoot(): ModuleWithProviders<MaterialModule> {
        return {
            ngModule: MaterialModule,
            providers: [
                MvdModalService,
                { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {
                    closeOnNavigation: true,
                    hasBackdrop: true,
                    panelClass: ['modal-dialog', 'modal-lg'] }
                }
            ]
        };
    }
}
